const handler = ( $ ) => {
	const $clickableElement = $( '.clickable-element' );

	if ( $clickableElement.length === 0 ) return;

	const clickHandler = ( e ) => {

		const link = $(e.currentTarget).data( 'link' );

		if ( ! link ) return false;

		const target = $(e.currentTarget).data( 'target' );

		if ( target === '_blank' ) {
			window.open( link, '_blank' );
		} else {
			window.location.href = link;
		}

		return false;
	};

	$clickableElement.on( 'click', clickHandler );
};

export default ( ( $ ) => $( handler ) )( jQuery );
